/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const pharmacyDispenses = sqliteTable('pharmacy_dispenses', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  dispense_number: text('dispense_number'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  invoice_id: text('invoice_id'),
  prescription_id: text('prescription_id'),
  status: text('status'),
  dispensed_at: text('dispensed_at'),
  dispensed_by: text('dispensed_by'),
  remarks: text('remarks'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
